import type { Dispatch, JSX, SetStateAction } from 'react';
import { useState } from 'react';
import type { ServiceOrganizationRole as Role } from '@common/enums';
import type { ServiceOrganizationRole } from '@common/interfaces/api/servicesApi';
import type { IServiceOrganizationSettingRoleDistribution } from '@frontend/components/interfaces/serviceOrganizationSettingRoleDistribution';
import type { ServiceOrganizationRoleDistributionsErrors } from './serviceOrganizationRoleDistributionTypes';
import { ServiceOrganizationSettingFormMode } from '../../types';
import { ServiceOrganizationSettingButtons } from '../ServiceOrganizationSettingButtons';
import { ServiceOrganizationsRoleDistributionsEdit } from './ServiceOrganizationRoleDistributionsEdit';

interface IServiceOrganizationsRoleDistributionsEditAndSettingButtonsProps {
    errorsByRole: Record<Role, ServiceOrganizationRoleDistributionsErrors>;
    handleClose: () => Promise<void>;
    handleSubmit: (items: IServiceOrganizationSettingRoleDistribution[]) => Promise<void>;
    isEquallyDistributedByRole: Record<Role, boolean>;
    isSaving: boolean;
    roles: Role[];
    serviceOrganizationRoleDistributions: IServiceOrganizationSettingRoleDistribution[];
    serviceOrganizationRoles: ServiceOrganizationRole[];
    setErrorsByRole: Dispatch<SetStateAction<Record<Role, ServiceOrganizationRoleDistributionsErrors>>>;
    setIsEquallyDistributed: (role: Role, value: boolean) => void;
    validateRoleDistributionsForRole: (items: IServiceOrganizationSettingRoleDistribution[], role: Role) => void;
}

export function ServiceOrganizationsRoleDistributionsEditAndSettingButtons(
    props: IServiceOrganizationsRoleDistributionsEditAndSettingButtonsProps
): JSX.Element {
    const [editServiceOrganizationRoleDistributions, setEditServiceOrganizationRoleDistributions] = useState<
        IServiceOrganizationSettingRoleDistribution[]
    >(props.serviceOrganizationRoleDistributions);
    const [showValidationAlerts, setShowValidationAlerts] = useState(false);

    return (
        <>
            <ServiceOrganizationsRoleDistributionsEdit
                errorsByRole={props.errorsByRole}
                isEquallyDistributedByRole={props.isEquallyDistributedByRole}
                roles={props.roles}
                serviceOrganizationRoleDistributions={editServiceOrganizationRoleDistributions}
                serviceOrganizationRoles={props.serviceOrganizationRoles}
                setErrorsByRole={props.setErrorsByRole}
                setIsEquallyDistributed={props.setIsEquallyDistributed}
                setServiceOrganizationRoleDistributions={setEditServiceOrganizationRoleDistributions}
                showValidationAlerts={showValidationAlerts}
                validateRoleDistributionsForRole={props.validateRoleDistributionsForRole}
            />

            <ServiceOrganizationSettingButtons
                isSaving={props.isSaving}
                mode={ServiceOrganizationSettingFormMode.edit}
                onClose={props.handleClose}
                onSave={async () => {
                    setShowValidationAlerts(true);
                    await props.handleSubmit(editServiceOrganizationRoleDistributions);
                }}
            />
        </>
    );
}
